import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';

const StartTestComponentButton = ({ passwordCorrect, startComponentAction, title }) => {
    return (
        <button
            type="button"
            className={`${styles.button} btn main-btn`}
            disabled={!passwordCorrect}
            onClick={startComponentAction}
        >
            <i className="fa fa-arrow-right" aria-hidden />
            <span dangerouslySetInnerHTML={{ __html: t('childTest.startTest', { title }) }} />
        </button>
    );
};

StartTestComponentButton.propTypes = {
    passwordCorrect: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    startComponentAction: PropTypes.func.isRequired,
};

export default StartTestComponentButton;
